<template>
<div>
    <form @submit.prevent="store" autocomplete="off">      
        <md-card>
            <header-form :rota="{name: 'pagamentosCreate'}" title="CADASTRAR PAGAMENTO" tooltip="Voltar" icon="fas fa-arrow-left" />

            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-30 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                        <h4>NOME:</h4>
                        <h4 class="text-label"><strong class="text-secondary">{{ cliente.nome }}</strong></h4>
                    </div>

                    <div class="md-layout-item md-size-55 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                        <h4>EMPRESA:</h4>
                        <h4 class="text-label"><strong class="text-secondary">{{ cliente.empresa }}</strong></h4>
                    </div>

                    <div class="md-layout-item md-size-15 md-xsmall-size-100 uppercase" style="margin-top: -15px">
                        <h4>LIMITE:</h4>
                        <h4 class="text-label"><strong class="text-secondary">{{ cliente.limiteDisponivel }}</strong></h4>
                    </div>
                </div>

                <div class="md-layout">
                    <div class="md-layout-item md-size-25 md-xsmall-size-100">
                        <md-field :class="{ 'md-error': errors.valor }">
                            <label>VALOR</label>
                            <md-input v-model="dados.valor" v-focus type="text" inputmode="numeric" autocomplete="off" class="pagamento" v-money> </md-input>
                            <slide-y-down-transition>
                                <md-icon class="error" v-show="errors.valor">close</md-icon>
                            </slide-y-down-transition>
                        </md-field>
                        <div v-if="errors.valor" class="validErro"> {{ errors.valor[0] }}</div>
                    </div>

                    <div class="md-layout-item md-size-25 md-xsmall-size-100">
                        <md-field :class="{ 'md-error': errors.parcelas }">
                            <label>PARCELAS</label>
                            <md-select v-model="dados.parcelas" name="pages">
                                <md-option v-for="item in parcelas" :key="item" :value="item">
                                    {{ item }}
                                </md-option>
                            </md-select>
                            <slide-y-down-transition>
                                <md-icon class="error" v-show="errors.parcelas">close</md-icon>
                            </slide-y-down-transition>
                        </md-field>
                        <div v-if="errors.parcelas" class="validErro"> {{ errors.parcelas[0] }}</div>
                    </div>

                    <div class="md-layout-item md-size-25 md-xsmall-size-100">
                        <md-field :class="{ 'md-error': errors.password }">
                            <label>SENHA</label>
                            <md-input v-model="dados.password" type="password" inputmode="numeric" autocomplete="off" class="pagamento" v-mask="['######']"> </md-input>
                            <slide-y-down-transition>
                                <md-icon class="error">close</md-icon>
                            </slide-y-down-transition>
                        </md-field>
                        <div v-if="errors.password" class="validErro"> {{ errors.password[0] }}</div>
                    </div>

                    <div class="md-layout-item md-size-25 md-xsmall-size-100">
                        <md-button type="submit" class="md-success md-round md-block" :disabled="loading">
                            <span class="md-label">
                                <md-icon class="material-icons">shopping_basket</md-icon>
                            </span>COMPRAR
                        </md-button>
                    </div>
                </div>
            </md-card-content>
        </md-card>
    </form>
</div>
</template>

<script>    
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'
import preLoader from '@/config/mixins/preLoader';
import Pagamento from '@/config/mixins/print/pagamento'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {
                parcelas: 1
            },
            cliente: {},
            parcelas: [],
            message: null,
            errors: {},
            loading: false
        }
    },
    mixins: [Notify, preLoader, Pagamento],

    created () {
        this.getCliente();
    },

    methods: {      
        getCliente() {
            let loader = this.openLoader('dots');
            this.$http.get(this.$urlAPI + 'clientes/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.cliente = response.data.dados[0];
                        this.errors = ''
                        this.message = null                     
                        this.numParcelas(this.cliente.num_parcela_id)
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.message = response.data.message;
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        numParcelas(parcela) {
            let parcelas = []
            for (let i = 1; i < parcela + 1; i++) {
                parcelas.push(i);
            }
            this.parcelas = parcelas;
        },

        store() {          
            this.loading = true 
            this.dados.cliente_id = this.cliente.id;
            this.dados.empresa_id = this.cliente.empresa_id;
            this.$http.post(this.$urlAPI + 'pagamentos', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.pagamento(response.data.dados)
                        this.success(response.data.message)
                        this.$router.push({ name: 'pagamentosCreate' });
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(() => {
                    this.loading = false
                });
        },

        pagamento(dataComprovante) {
            this.printPagamento(dataComprovante[0])
        }
    }
};
</script>

<style>
.text-label {
    margin-top: -25px !important;
}

.md-toggle-password,
.error {
    visibility: hidden !important;
}
</style>
